import React from 'react';
import RtRecordingTime from './rt-recording-time';
export default function RtDetailes({ isAf, isStopped, record }) {
    return (React.createElement("div", { className: 'info-bottom-section mt-0' },
        React.createElement("div", { className: ` size-2 status-af pl-5 ${isAf || isStopped ? 'red-team' : 'green-team'}` }, isStopped ? 'Measurement stopped' : `AF ${!isAf ? 'not' : ''} detected`),
        React.createElement(RtRecordingTime, { record: record })));
}
